import {
  rgbaStringToHsva,
  rgbStringToHsva,
  hsvaToHex,
  color as prepareColor,
} from '@uiw/color-convert'

export function parseColorStringToHex(string, disableAlpha = true) {
  let parsedColor = disableAlpha ? '#ffffff' : '#ffffff00'
  if (isValidHex(string, disableAlpha)) {
    return string
  } else if (`${string}`.startsWith('rgb(')) {
    parsedColor = rgbStringToHsva(string)
  } else if (`${string}`.startsWith('rgba(')) {
    parsedColor = rgbaStringToHsva(string)
  }
  return hsvaToHex(prepareColor(parsedColor)?.hsva)
}

export const isValidHex = (value, disableAlpha = true) => {
  const regex = disableAlpha
    ? /^#?([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6})$/
    : /^#?([A-Fa-f0-9]{3}[A-Fa-f0-9]{1}|[A-Fa-f0-9]{6}[A-Fa-f0-9]{2})$/
  return regex.test(value)
}

export const formatHex = (value, skipOpacity = false, skipConversion = false) => {
  value = `${value}`.replaceAll(/\#/g, '').toUpperCase()
  if (value.length === 3 && skipConversion === false) {
    value = value
      .split('')
      .map((c) => c + c)
      .join('')
  }
  if (value.length > 6 && skipOpacity) {
    return value.substring(0, 6)
  }
  return value
}

export function compressColor(value) {
  const preparedColor = formatHex(value, true, true)
  if (
    preparedColor[0] === preparedColor[1] && 
    preparedColor[2] === preparedColor[3] && 
    preparedColor[4] === preparedColor[5]
  ) {
    return `#${preparedColor[0]}${preparedColor[2]}${preparedColor[4]}`
  }
  return value
}